<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'

    import { tableData } from './constants/dataAdvancedtable'
    import * as axios from "axios";
    const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';

    /**
     * Advanced table component
     */
    export default {
        page: {
            title: 'Prebid Adunits',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                modalData: [],
                tableData: tableData,
                title: 'Prebid Adunits',
                items: [
                    {
                        text: 'Admin',
                        href: '/',
                    },
                    {
                        text: 'Prebid Adunits',
                        href: '/',
                        active: true
                    },
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 100,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: 'age',
                sortDesc: false,
                fields: [
                    { key: 'id', sortable: true },
                    { key: 'domain', sortable: true },
                    { key: 'appnexus', sortable: true, class: 'cursor-pointer' },
                    { key: 'rubicon', sortable: true, class: 'cursor-pointer' },
                    { key: 'criteo', sortable: true, class: 'cursor-pointer' },
                ],
            }
        },
        computed: {
            /**
             * Total no. of records
             */
            rows() {
                return this.tableData.length
            },
        },
        mounted() {
            // Set the initial number of items
            this.totalRows = this.items.length;
            this.fetchData();
        },
        methods: {
            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1
            },
            async fetchData() {
                const fetchSitesResponse = await axios(DASHBOARD_API_URL + `config/prebid-adunits`);
                this.tableData = fetchSitesResponse.data;
            },
            async openAdunitsModal(siteId, providerName) {
                this.$bvModal.show('modal-prebid-adunits');
                try {
                    const response = await axios({
                        method: 'get',
                        url: DASHBOARD_API_URL + `config/prebid-adunits/${siteId}/${providerName}`,
                    });
                    if (response.status === 200) {
                        this.modalData = response.data;
                    }
                } catch (e) {
                    console.log(e)
                }

            }
        },
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-modal
                id="modal-prebid-adunits"
                class="text-capitalize"
                size="lg"
                :title="modalData.title"
                title-class="font-18"
                hide-footer
        >
            <div class="table-responsive mb-0">
                <table class="table table-bordered mb-0">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th v-for="key in modalData.headers"> {{ key }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in modalData.data">
                        <th> {{ item.size }}</th>
                        <td v-for="value in item.values"> {{ value.value }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </b-modal>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title">Prebid Adunits</h4>
                        <p class="text-muted font-13 mb-4"></p>
                        <div class="row mb-md-2">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    @filtered="onFiltered"
                            >
                                <template v-slot:cell(rubicon)="data">
                                    <span
                                            @click="openAdunitsModal(data.item.id, 'rubicon')"
                                            :class="{
                                            'text-success': data.item.rubicon > 0,
                                            'text-danger': data.item.rubicon === 0,
                                            }"

                                    >
                                        {{ data.item.rubicon }}/4
                                    </span>
                                </template>
                                <template v-slot:cell(criteo)="data">
                                    <span
                                            @click="openAdunitsModal(data.item.id, 'criteo')"
                                            :class="{
                                            'text-success': data.item.criteo > 0,
                                            'text-danger': data.item.criteo === 0,
                                            }"

                                    >
                                        {{ data.item.criteo }}/4
                                    </span>
                                </template>
                                <template v-slot:cell(appnexus)="data">
                                    <span
                                            @click="openAdunitsModal(data.item.id, 'appnexus')"
                                            :class="{
                                            'text-success': data.item.appnexus > 0,
                                            'text-danger': data.item.appnexus === 0,
                                            }"

                                    >
                                        {{ data.item.appnexus }}/4
                                    </span>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
